import request from '../request'

export function getMessagesList(status) {
  return request({
    url: '/api/v3/users/messages-list',
    method: 'get',
    params: { status, pageSize: 5 }
  })
} 